// SAB-431: minimal site-wide footer. Created to host the "Manage cookie
// preferences" link required by the consent banner ticket. Linked legal
// routes (/privacy, /terms, /cookies, /state-availability) all render in-app
// as of SAB-522 (/terms + /cookies were 404, /privacy blank-redirected).
//
// SAB-429 (homepage redesign) is expected to introduce a richer "trust
// footer" that will supersede or extend this. Keep styling minimal here
// — don't over-invest in visuals that will be replaced.
import { Link, useLocation } from 'react-router-dom'
import { resetConsent } from '@/lib/consent'

const LEGAL_LINKS: Array<{ label: string; href: string }> = [
  { label: 'Support', href: '/support' },
  { label: 'Privacy', href: '/privacy' },
  { label: 'Terms', href: '/terms' },
  { label: 'Cookies', href: '/cookies' },
  { label: 'Responsible Gaming', href: '/responsible-gaming' },
  { label: 'Withdrawals', href: '/withdrawals' },
  { label: 'State Availability', href: '/state-availability' },
]

export default function Footer() {
  // Superseded by src/components/marketing/MarketingFooter on the homepage
  // (SAB-430). That footer hosts its own Manage-cookie-preferences link, so
  // the SAB-431 consent-reset path stays intact on `/`.
  const { pathname } = useLocation()
  if (pathname === '/') return null

  return (
    <footer className="border-t border-border/40 bg-background mt-auto">
      <div className="mx-auto max-w-6xl px-4 py-6 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6 text-xs text-muted-foreground">
        <span className="shrink-0">© {new Date().getFullYear()} Sabotage Fantasy</span>
        <nav className="flex flex-wrap items-center gap-x-4 gap-y-2 sm:mr-auto">
          {LEGAL_LINKS.map(l => (
            <Link
              key={l.href}
              to={l.href}
              className="hover:text-foreground transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <button
          type="button"
          onClick={resetConsent}
          className="text-left sm:text-right hover:text-foreground transition-colors underline-offset-4 hover:underline"
        >
          Manage cookie preferences
        </button>
      </div>
    </footer>
  )
}
